let dpr = window.devicePixelRatio;
let PI = Math.PI;
const colors = ['#FFFF00', '#8FFF7F', '#1FF5FF', '#8FFF7F'];
const colors2 = ['#FFFF00', '#8FFF7F', '#1FF5FF', '#8FFF7F'];
const step = 100;
class Particle{
	constructor(count, angle, width){
		this.x = window.innerWidth/2;
		this.y = window.innerHeight/2;
		this.size 	= Math.floor( Math.random()*10 ) + 5;
		if( count > 5 ){
			this.size 	= Math.floor( Math.random()*10 ) + 10;
		}
		this.life 	= 2000;
		this.vec 	= angle;
		this.startTime = kv.getTime();
		this.endX = [];
		this.endY = [];
		this.id = count;
		this.alive = true;
		this.is_stop = false;
		this.width = width;
		this.colors = generateGradient(colors, width);
		this.colorStart = 0;
		this.draw();
	}
	draw(){
		
		let $this = this;
		let now 		= Date.now();
		let timeDiff 	= now - this.startTime;
		let diff 		= timeDiff / this.life;
		let easeDiff 	= easeOutQuad(diff);
		let endPos 		= window.innerHeight/6 + this.width*6;
		let baseX 		= window.innerWidth/2 + window.innerWidth*.35 - this.size/2;
		let baseY 		= window.innerHeight/2 - this.size/2;
		let limit 		= .55;
		if (window.matchMedia('all and (min-width : 864px)').matches) {
			baseX 		= window.innerWidth/2 + window.innerWidth*.28 - this.size/2;
			baseY 		= kv.cvsWrap.clientHeight/2 - this.size/2;
			if( this.id < 5){
				endPos 	= window.innerWidth/8 + this.width*6;
			}else{
				endPos 	= window.innerWidth/3 + this.width*6;
				limit = .7;
			}
		}
		
		this.x = Math.cos( this.vec*PI /180)*timeDiff + baseX;
		this.y = Math.sin( this.vec*PI /180)*timeDiff + baseY;
		let len = this.width;
		
		for(let i = 0; i < len; i++){
			let opacity = 1 - .5/len*i;
			//console.log(opacity);
			
			//kv.ctx.fillStyle = generateGradient(colors, numSteps, i);
			//let x = Math.cos( this.vec*PI /180)*(timeDiff - i*10)+ baseX;
			//let y = Math.sin( this.vec*PI /180)*(timeDiff - i*10) + baseY;
			let easedTrailDiff = easeOutQuad( (timeDiff) / this.life) + .05;
			let sizeDiffTime = diff + 10;
			if( this.width > 120){
				sizeDiffTime = diff + 20;
			}
			if(easedTrailDiff >= limit){
				this.alive 		= true;
				easedTrailDiff 	= limit;
				this.is_stop 	= true;
				//delete kv.particles[$this.id];
			}
			
			let colorCount = len - this.colorStart + i;
			colorCount = colorCount >= len ? i : colorCount;
			kv.ctx.fillStyle 	= `rgba( ${this.colors[colorCount][0]}, ${this.colors[colorCount][1]}, ${this.colors[colorCount][2]}, ${opacity})`;
			
			if( !this.is_stop ){
				let size = this.size - (this.size/len)*i/2.5;
				let diffXY = i*size;
				if( this.id < 5){
					if(diffXY > i*size/2){
						diffXY = i*size/2;
					}
				}else{
					if(diffXY > i*size/2){
						diffXY = i*size/2;
					}
				}
				
				let changeX = Math.cos(this.vec * PI / 180) * easedTrailDiff * (endPos - diffXY);
				let changeY = Math.sin(this.vec * PI / 180) * easedTrailDiff * (endPos - diffXY);
				let x = changeX + baseX;
				let y = changeY + baseY;
				
				kv.ctx.beginPath();
				
				kv.ctx.arc(x*dpr, y*dpr, size, 0, 2*Math.PI);
				kv.ctx.closePath();
				kv.ctx.fill();
				//kv.ctx.globalAlpha = opacity;
				this.endX[i] = changeX;
				this.endY[i] = changeY;
			}else{
				let size = this.size - (this.size/len)*i/2.5;
				let diffXY = i*size;
				if(diffXY > i*size/2){
					diffXY = i*size/2;
				}
				//kv.ctx.fillStyle 	= `rgb( ${this.colors2[colorCount][0]}, ${this.colors2[colorCount][1]}, ${this.colors2[colorCount][2]})`;
				if( this.id === 0 && i === 0){
					//console.log(colorCount)
				}
				//let x = this.endX[i];
				//let y = this.endY[i];
				
				let x = this.endX[i] + baseX;
				let y = this.endY[i] + baseY;
				
				kv.ctx.beginPath();
				kv.ctx.arc(x*dpr, y*dpr, size, 0, 2*Math.PI);
				kv.ctx.closePath();
				kv.ctx.fill();
				//kv.ctx.globalAlpha = opacity;
			}
		}
		this.colorStart++;
		if( this.colorStart >= len){
			this.colorStart = 0;
		}
	}
}

export let kv = {
	ctx: null,
	cvs: null,
	particles: [],
	frameID: 0,
	currentLen: 5,
	currentCount: 0,
	colors: [],
	init: function(){
		/*
		this.cvsWrap 	= document.querySelector("#c-kv");
		this.cvs 		= document.querySelector("#c-kv canvas#laser");
		this.ctx 		= this.cvs.getContext("2d");
		*/
		this.resize();
		//kv.colors = generateGradient(colors, step);
		let $kv = document.querySelector("#c-kv");
		if( !$kv.classList.contains("show") ){
			$kv.classList.add("show");
			let wait = 2400;
			if (window.matchMedia('all and (min-width : 864px)').matches) {
				wait = 2500;
			}
			setTimeout(function(){
				//kv.createParticle();
				//console.log(kv.colors[0]);
				//kv.update();
				document.querySelector("body").classList.remove("disable_nav");
			}, wait);
		}
	
	},
	createParticle: function(){
		let particleMax	= 10;
		let count 		= 0;
		
		setParticle();
		function setParticle(){
			let rand = 360/50;
			let width = 75;
			if( count > 5){
				width = 160;
			}
			kv.particles[count] = new Particle(count, Math.floor( 360/10 )*count + Math.floor( Math.random()*rand -90), width);
			count++;
			if( count < particleMax ){
				setTimeout(function(){
					setParticle();
				}, Math.random()*100 );
			}
		}
	},
	deleteParticle: function(){
		kv.currentCount
	},
	resize: function(){
		//let w = this.cvsWrap.clientWidth;
		//let h = this.cvsWrap.clientHeight;
		//this.cvs.setAttribute("width", w*dpr);
		//this.cvs.setAttribute("height", h*dpr);
		
		//this.cvs.style.width = w + "px";
		//this.cvs.style.height = h + "px";
	},
	update: function(){
		if( kv.frameID % 10 === 0){
			kv.resize();
		}
		kv.ctx.clearRect(0, 0, kv.cvs.width, kv.cvs.height);
		for(let i = 0; i < kv.particles.length; i++){
			let p = kv.particles[i];
			if( p ){
				p.draw();
			}
		}
		kv.frameID++;
		kv.frameID = requestAnimationFrame(kv.update);
	},
	getTime: function(){
		let n = new Date();
		return n.getTime();
	}
}
function easeOutQuad(x) {
	return 1 - (1 - x) * (1 - x);
}
function easeOutCubic(x) {
	return 1 - Math.pow(1 - x, 3);
}
function hexToRgb(hex) {
	// 16進数をRGBに変換
	let bigint = parseInt(hex.slice(1), 16);
	let r = (bigint >> 16) & 255;
	let g = (bigint >> 8) & 255;
	let b = bigint & 255;
	return [r, g, b];
}
function interpolateColor(color1, color2, factor) {
	if (factor === undefined) factor = 0.5;
	let result = color1.slice();
	for (let i = 0; i < 3; i++) {
		result[i] = Math.round(result[i] + factor * (color2[i] - result[i]));
	}
	return result;
}
function generateGradient(colors, numSteps) {
	let gradient = [];
	let stepsPerSegment = numSteps / (colors.length - 1);
	
	for (let i = 0; i < colors.length - 1; i++) {
		let color1 = hexToRgb(colors[i]);
		let color2 = hexToRgb(colors[i + 1]);
		for (let j = 0; j < stepsPerSegment; j++) {
			let factor = j / stepsPerSegment;
			let interpolatedColor = interpolateColor(color1, color2, factor);
			gradient.push([...interpolatedColor, 1.0]); // RGBA形式で出力（アルファ値は1.0固定）
		}
	}
	return gradient;
}
function generateGradient2(colors, numSteps) {
	let gradient = [];
	let stepsPerSegment = numSteps / (colors.length - 1);
	
	for (let i = 0; i < colors.length - 1; i++) {
		let color1 = hexToRgb(colors[i]);
		let color2 = hexToRgb(colors[i + 1]);
		for (let j = 0; j < stepsPerSegment; j++) {
			let factor = j / stepsPerSegment;
			let interpolatedColor = interpolateColor(color1, color2, factor);
			gradient.push([...interpolatedColor, 1.0]); // RGBA形式で出力（アルファ値は1.0固定）
		}
	}
	return gradient;
}